import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CommuterTrafficFee } from '../../commuter-traffic-fees/commuter-traffic-fee.interface';
import { CommuterTrafficFeeService } from './commuter-traffic-fee.service';

const service = new CommuterTrafficFeeService();

export interface CommuterTrafficFeeState {
   commuterTrafficFeesOverview?: PaginatedResponse<CommuterTrafficFee>;
}

const CommuterTrafficFeeStore: Module<CommuterTrafficFeeState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_COMMUTER_TRAFFIC_FEES(state, overview: PaginatedResponse<CommuterTrafficFee>) {
         state.commuterTrafficFeesOverview = overview;
      },
      ADD_COMMUTER_TRAFFIC_FEE(state, commuterTrafficFee: CommuterTrafficFee) {
         state.commuterTrafficFeesOverview?.data?.push(commuterTrafficFee);
      },
      CHANGE_COMMUTER_TRAFFIC_FEE(state, commuterTrafficFee: CommuterTrafficFee) {
         const index = (state.commuterTrafficFeesOverview?.data || []).findIndex((ctf) => ctf.id === commuterTrafficFee.id);
         if (index - 1) state.commuterTrafficFeesOverview?.data.splice(index, 1, commuterTrafficFee);
      },
      DELETE_COMMUTER_TRAFFIC_FEE(state, commuterTrafficFeeId: number) {
         const index = (state.commuterTrafficFeesOverview?.data || []).findIndex((ctf) => ctf.id === commuterTrafficFeeId);
         if (index - 1) state.commuterTrafficFeesOverview?.data.splice(index, 1);
      },
   },
   actions: {
      async getCommuterTrafficFees(context, payload: { companyId: number; query: LocationQuery }) {
         const response = await service.getCommuterTrafficFees(payload.companyId, payload.query);
         context.commit('SET_COMMUTER_TRAFFIC_FEES', response);
         return response;
      },
      async getCommuterTrafficFee(context, payload: { companyId: number; commuterTrafficFeeId: number }) {
         return await service.getCommuterTrafficFee(payload.companyId, payload.commuterTrafficFeeId);
      },
      async createCommuterTrafficFee(context, payload: { companyId: number; commuterTrafficFee: CommuterTrafficFee }) {
         const response = await service.postCommuterTrafficFee(payload.companyId, payload.commuterTrafficFee);
         context.commit('ADD_COMMUTER_TRAFFIC_FEE', response);
         return response;
      },
      async changeCommuterTrafficFee(
         context,
         payload: { companyId: number; commuterTrafficFeeId: number; commuterTrafficFee: CommuterTrafficFee },
      ) {
         const response = await service.putCommuterTrafficFee(payload.companyId, payload.commuterTrafficFeeId, payload.commuterTrafficFee);
         context.commit('CHANGE_COMMUTER_TRAFFIC_FEE', response);
         return response;
      },
      async deleteCommuterTrafficFee(context, payload: { companyId: number; commuterTrafficFeeId: number }) {
         const response = await service.deleteCommuterTrafficFee(payload.companyId, payload.commuterTrafficFeeId);
         context.commit('DELETE_COMMUTER_TRAFFIC_FEE', payload.commuterTrafficFeeId);
         return response;
      },
      async importCommuterTrafficFeeBatches(context, payload: { companyId: number; importFile: File }) {
         return await service.importCommuterTrafficFeeBatches(payload.companyId, payload.importFile);
      },
      async indexCommuterTrafficFees(context, companyId: number) {
         return await service.indexCommuterTrafficFees(companyId);
      },
   },
};

export default CommuterTrafficFeeStore;
